import { Button } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const linkCommand =
  (linkEditorComponentId) =>
  ({ editor, range }) => {
    const linkCommandEvent = new CustomEvent('linkCommand', { detail: { linkEditorComponentId } });

    if (range) {
      editor.chain().focus().deleteRange(range).run();
    }

    document.dispatchEvent(linkCommandEvent);
  };

const Link = ({ editor, linkEditorComponentId, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<LinkOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => linkCommand(linkEditorComponentId)({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="EMBED_LINK" defaultMessage="Embed link" />
        </div>
      )}
    </Button>
  );
};

export default Link;
